import { render, staticRenderFns } from "./shebao.vue?vue&type=template&id=4c0e3d7c&scoped=true&"
import script from "./shebao.vue?vue&type=script&lang=js&"
export * from "./shebao.vue?vue&type=script&lang=js&"
import style0 from "./shebao.vue?vue&type=style&index=0&id=4c0e3d7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e3d7c",
  null
  
)

export default component.exports